import request from "@network/index";
import { Page, Row, Rows, UploadData } from "./types";

/** 조회 */
export const requestFetchList = async <T>(url: string, params: string) => {
  const { data } = await request<void, Rows<T>>({
    method: "get",
    url: `${url}?${params}`,
  });
  return data;
};

/** 상세 조회 */
export const requestFetchDetail = async <T>(
  url: string,
  id?: string | (string | null)[],
) => {
  if (!id) return;
  const { data } = await request<void, Row<T>>({
    method: "get",
    url: `${url}/${id}`,
  });
  return data.row;
};

/** 삭제 */
export const requestDelete = async (
  url: string,
  id: string | (string | null)[],
) => {
  if (!id) return;
  await request<void, void>({
    method: "delete",
    url: `${url}/${id}`,
  });
};

/** 이미지 업로드 */
export const requestImageUpload = async (uploadData: UploadData) => {
  const formData = new FormData();
  formData.append("image", uploadData.imageFile);
  formData.append("category", uploadData.category);
  try {
    const { data } = await request<FormData, Rows<string>>({
      method: "post",
      url: "common/file-upload",
      requestBody: formData,
      isMultipart: true,
    });
    return data.rows[0];
  } catch (e) {
    console.error("IMAGE UPLOAD ERROR 🚀 >>>>> :", e);
  }
};

/** 딥링크 생성 */
export const deepLink = async (page: Page, id: string) => {
  const deepLinkHost = process.env.REACT_APP_DEEP_LINK_HOST;
  let path = "";

  switch (page) {
    case "notice":
      path = `${deepLinkHost}/NoticeDetail?pageId=${id}`;
      break;
    case "event":
      path = `${deepLinkHost}/EventDetail?pageId=${id}`;
      break;
    case "faq":
      path = `${deepLinkHost}/FAQ?pageId=${id}`;
      break;
    case "chargerresolution":
      path = `${deepLinkHost}/ChargerResolutionDetail?pageId=${id}`;
      break;
    case "serviceintroduction":
      path = `${deepLinkHost}/ServiceIntroductionDetail?pageId=${id}`;
      break;

    default:
      return "";
  }

  const { data } = await request<{ longUrl: string }, string>({
    method: "post",
    url: "/common/convert-to-short-url",
    requestBody: { longUrl: path },
  });

  return data;
};
